var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{attrs:{"id":"users"}},_vm._l((_vm.users),function(user,index){return _c('li',{key:index,staticClass:"user"},[_vm._v(" "+_vm._s(user.username)+" "),(user.typing)?_c('span',[_vm._v("is typing...")]):_vm._e()])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }